// Helper function to set nested property using dot notation
export const setNestedValue = (obj, path, value) => {
    const pathArray = Array.isArray(path) ? path : path.split('.');
    let current = obj;

    for (let i = 0; i < pathArray.length - 1; i++) {
        const key = pathArray[i];
        if (!current[key]) {
        current[key] = {};
        }
        current = current[key];
    }

    current[pathArray[pathArray.length - 1]] = value;
    return obj;
};

// Helper function to get nested property using dot notation
export const getNestedValue = (obj, path) => {
    if (!path) return undefined;
    const pathArray = Array.isArray(path) ? path : path.split('.');
    let current = obj;

    for (const key of pathArray) {
        if (current === undefined || current === null) {
        return undefined;
        }
        current = current[key];
    }

    return current;
};